import { useMemo } from "react";
import { createTachographPolicy } from "../utilities/tachographPolicy";
import { useGlobalEntitySettings } from "@/hooks/tachograph/useGlobalEntitySettings";

/** How often driver cards and vehicle units have to be read out in this database. */
export function useTachographPolicy() {
  const { data: settings, isLoading, isError } = useGlobalEntitySettings();

  const policy = useMemo(() => createTachographPolicy(settings ?? []), [settings]);

  return { policy, isLoading, isError };
}
